const mobile = "@media screen and (max-width:800px)";

export default (theme) => ({
  wrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "calc(100vh - 80px - 200px)",
    padding: "64px 24px 120px",
    textAlign: "center",
    [mobile]: {
      minHeight: "calc(100vh - 64px - 160px)",
      padding: "48px 16px 80px",
    },
  },
  illustration: {
    width: 280,
    height: 200,
    marginBottom: 32,
    [mobile]: {
      width: 224,
      height: 160,
      marginBottom: 24,
    },
  },
  desc: {
    margin: 0,
    maxWidth: 520,
    fontSize: 14,
    lineHeight: 1.6,
    color: theme.palette.text[100],
    [mobile]: {
      fontSize: 13,
    },
  },
  link: {
    display: "inline-flex",
    alignItems: "center",
    gap: 2,
    marginTop: 16,
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.primary.main,
    textDecoration: "none",
    transition: "opacity 0.2s",
    "&:hover": {
      opacity: 0.85,
    },
  },
});
